import { useState, useEffect } from 'react';

import type { DisclosureShort } from '../../../output/models';
import type { GetStockMonthliesRequest } from '../../../output/apis/StocksApi';

import { config } from '../../../config';
import { StocksApi } from '../../../output/apis/StocksApi';

export const useMonthlies = (code: string, selected: boolean): DisclosureShort[] | undefined => {
  const [data, setData] = useState<DisclosureShort[] | undefined>();
  const [dataInit, setDataInit] = useState<boolean>(false);

  useEffect(() => {
    setDataInit(false);
  }, [code]);

  useEffect(() => {
    if (dataInit || !selected) {
      return;
    }
    setData(undefined);

    const req: GetStockMonthliesRequest = { code };

    new StocksApi(config)
      .getStockMonthlies(req)
      .then((res) => {
        setData(res.data);
        setDataInit(true);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [code, selected, dataInit]);

  return data;
};
